// src/components/ProtectedRoute.js

import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from '../Layout/Sidebar';

const ProtectedRoute = ({ element: Component }) => {
    const { auth } = useAuth();

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [contentWidth, setContentWidth] = useState(window.innerWidth);
    const [maxWidthClass, setMaxWidthClass] = useState('max-w-full');

    const toggleSidebar = () => {
        setIsSidebarOpen((prev) => !prev);
    };

    useEffect(() => {
        const handleResize = () => {
            setContentWidth(window.innerWidth);            
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (contentWidth < 1000) {
            setIsSidebarOpen(false);
        } else {
            setIsSidebarOpen(true);
        }
        
        setMaxWidthClass('w-full p-4');        
    }, [contentWidth])

    if (!auth.isAuthenticated) {
        return <Navigate to="/admin-login" replace />;
    }

    return (
        <div className={`app-container ${isSidebarOpen ? 'sidebar-open' : ''}`}>
            <Sidebar
                toggleSidebar={isSidebarOpen}
                user={auth.user}
                onToggleClick={() => toggleSidebar()}
            />
            <div className={`relative ${maxWidthClass} overflow-x-auto`}>
                <Component />
            </div>
        </div>
    );
};

export default ProtectedRoute;
